import { render, staticRenderFns } from "./paper-result-ai-h5.vue?vue&type=template&id=2c32bb6c&scoped=true"
import script from "./paper-result-ai-h5.vue?vue&type=script&lang=ts"
export * from "./paper-result-ai-h5.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-ai-h5.vue?vue&type=style&index=0&id=2c32bb6c&prod&lang=scss&scoped=true"
import style1 from "./paper-result-ai-h5.vue?vue&type=style&index=1&id=2c32bb6c&prod&lang=scss"
import style2 from "./paper-result-ai-h5.vue?vue&type=style&index=2&id=2c32bb6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32bb6c",
  null
  
)

export default component.exports